import React from 'react';
import { useRouteMatch } from 'react-router';
import { makeStyles, Grid, Typography } from '@material-ui/core';

import { SideNav } from 'components/';
import useGlobalStyles from 'hooks/useGlobalStyles';
import useShows from 'hooks/useShows';
import { AccountMenu } from 'components/Navigation';

interface Props {
  children: React.ReactNode;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    height: '100vh'
  },
  main: {
    padding: '16px',
    flexGrow: 1,
  },
});

const DashboardPage: React.SFC<Props> = (props) => {
  const { children } = props;
  const classes = useStyles();
  const globalStyles = useGlobalStyles();

  const { selectedShow } = useShows();
  const matchesLinks = useRouteMatch('/links');
  const matchesSettings = useRouteMatch('/settings');

  const getTitle = () => {
    if (matchesLinks) return 'Links';
    if (matchesSettings) return 'Settings';
  };

  const getOverline = () => {
    if (matchesSettings) return 'account';
    else return selectedShow.title;
  }

  return (
    <div className={classes.root}>
      <SideNav />
      <main className={classes.main}>
        <Grid
          className={globalStyles.gridNoSpacing}
          container
          spacing={0}
        >
          <Grid item xs={12}>
            <Grid 
              className={globalStyles.gridNoSpacing}
              container
              spacing={4}
              alignItems="center"
            >
              <Grid item sm={6}>
                <Typography variant="overline">{getOverline()}</Typography>
                <Typography variant="h1">{getTitle()}</Typography>
              </Grid>
              <Grid item sm={3} />
              <Grid item sm={3}>
                <AccountMenu />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid 
              className={globalStyles.gridNoSpacing}
              container
              spacing={4}
            >
              {children}
            </Grid>
          </Grid>
        </Grid>
      </main>
    </div>
  );
}

export default DashboardPage;
